export var FloodLightsActions;
(function (FloodLightsActions) {
    FloodLightsActions["FLOOD_LIGHTS_VISIBILITY"] = "FLOOD_LIGHTS_VISIBILITY";
    FloodLightsActions["FLOOD_LIGHTS_EVENT_NAME"] = "FLOOD_LIGHTS_EVENT_NAME";
})(FloodLightsActions || (FloodLightsActions = {}));
export function setFloodLightsVisibility(visible) {
    return {
        type: FloodLightsActions.FLOOD_LIGHTS_VISIBILITY,
        visible
    };
}
export function setFloodLightsEventName(isClickTriggered = false, eventName, productId) {
    return {
        type: FloodLightsActions.FLOOD_LIGHTS_EVENT_NAME,
        eventName,
        productId,
        isClickTriggered
    };
}
